module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.9.0-270.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.9.0.md
// module id = 713
// module chunks = 228